<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
      <div class="ml-1">
        {{ getOrganizationName() }}
      </div>
    </div>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <notification />
      <locale />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { avatarText } from '@core/utils/filter'
import Locale from './app-navbar/components/Locale.vue'
import Notification from './app-navbar/components/Notification.vue'
import useJwt from '@/auth/jwt/useJwt'
import userDropdown from '@/layouts/components/app-navbar/components/UserDropdown.vue'
import store from '@/store'

export default {
  components: {
    BLink,
    BNavbarNav,
    // Navbar Components
    DarkToggler,
    Locale,
    Notification,
    userDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userData: store.state.auth.user,
      avatarText,
    }
  },
  methods: {
    getOrganizationName() {
      return this.userData.org_id ? this.$langName(this.userData.org_id.name) : null
    },
  },

}
</script>
